import React from 'react';
import { isNullOrUndefined } from 'util';
import { EMPTY_STRING } from './../../utils/constants';

const HeaderComponent = (props) => {
   return(
       <React.Fragment>
           <h2>{props.headerName}</h2>
           <hr className={!isNullOrUndefined(props.headerClass) ? props.headerClass : EMPTY_STRING}/>
       </React.Fragment>
   )

};

export default HeaderComponent;